module.exports = __webpack_public_path__ + "img/section5-item3.f9c63283.png";